import { render, staticRenderFns } from "./BasicProductCustomization.vue?vue&type=template&id=6bd0d7ac"
import script from "./BasicProductCustomization.vue?vue&type=script&lang=js"
export * from "./BasicProductCustomization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports